<script setup>
    import { ref, defineProps, defineEmits } from 'vue';
    // ----------------------------
    // Props
    // ----------------------------
    const props = defineProps({
        tabs: {
            type: Array,
            required: true,
        },
        modelValue: {
            type: String,
            default: '',
        },
    });

    // ----------------------------
    // Emits
    // ----------------------------
    const emit = defineEmits(['changeTab']);

    // ----------------------------
    // リアクティブ変数
    // ----------------------------
    const activeTabId = ref('');

    // ----------------------------
    // 関数
    // ----------------------------
    // タブの変更を検知
    function changeTab(tabId) {
        activeTabId.value = tabId;
        // 親コンポーネントに選択されたタブを伝える
        emit('changeTab', activeTabId.value);
    }
</script>

<template>
    <ul class="tab">
        <li v-for="(tab, index) in props.tabs" :key="index">
            <button @click="changeTab(tab.type)" type="button" :class="[modelValue === tab.type ? 'selected' : '', tab.class]">
                {{ tab.name }}
            </button>
        </li>
    </ul>
</template>

<style></style>
